import React from 'react';
import PropTypes from 'prop-types';

const VENUE_COLOR = { dot: '#2E90FA', bg: '#EFF8FF', fg: '#175CD3', bd: '#B2DDFF' };

const venueColorVars = () => {
  const c = VENUE_COLOR;
  return {
    '--ar-venue-dot': c.dot,
    '--ar-venue-bg': c.bg,
    '--ar-venue-fg': c.fg,
    '--ar-venue-bd': c.bd,
  };
};

const MatrixCell = ({ venueOwnership, settingId, isEnabled, isDefault, onCycleCell }) => {
  const cellClass = [
    'ar-matrix__cell',
    isDefault && 'ar-matrix__cell--default',
    !isEnabled && !isDefault && 'ar-matrix__cell--disabled',
  ]
    .filter(Boolean)
    .join(' ');

  const venueName = venueOwnership.venue?.name || venueOwnership.name;
  const ariaLabel = isDefault
    ? `${venueName}: default — click to disable`
    : isEnabled
    ? `${venueName}: enabled — click to set as default`
    : `${venueName}: disabled — click to enable`;

  const title = isDefault
    ? 'Default for this venue — click to disable'
    : isEnabled
    ? 'Enabled — click to set as default'
    : 'Disabled — click to enable';

  return (
    <button
      type="button"
      className={cellClass}
      style={venueColorVars()}
      onClick={() => onCycleCell(venueOwnership.id, settingId)}
      aria-label={ariaLabel}
      aria-pressed={isEnabled || isDefault}
      title={title}
    >
      {isDefault ? (
        <span className="ar-matrix__cell-star">
          <i className="fas fa-star" style={{ fontSize: 11 }} />
        </span>
      ) : isEnabled ? (
        <span className="ar-matrix__cell-checkbox">
          <i className="fas fa-check" style={{ fontSize: 11 }} />
        </span>
      ) : (
        <span className="ar-matrix__cell-empty" />
      )}
    </button>
  );
};

MatrixCell.propTypes = {
  venueOwnership: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    venue: PropTypes.shape({ name: PropTypes.string }),
  }).isRequired,
  settingId: PropTypes.number.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  isDefault: PropTypes.bool.isRequired,
  onCycleCell: PropTypes.func.isRequired,
};

export { venueColorVars };
export default MatrixCell;
